import { type FC, memo, type ReactNode } from "react";
import { Button } from "../Button/Button";
import { URL_RECONDITIONABLE } from "~/utils/url/staticUrls";
import { PopperTooltip } from "../Tooltip";
import classes from "./RichTooltip.module.less";
import Tag from "../Tag/Tag";

interface RichTooltipProps {
  message?: ReactNode;
  linkText?: string;
  linkUrl?: string;
  tooltipSide?: "left" | "right" | "bottom";
  chipText: string;
  ChipIcon?: React.ReactElement;
  variant?: string;
  tagStyle?: string;
}

const RichTooltip: FC<RichTooltipProps> = (props) => {
  const {
    message,
    linkText,
    tooltipSide = "bottom-start",
    variant = "default",
    linkUrl = URL_RECONDITIONABLE,
    ChipIcon,
    chipText,
    tagStyle,
  } = props;

  if (!message) {
    return (
      <Tag variant={variant} icon={ChipIcon} iconPosition="start" className={tagStyle}>
        {chipText}
      </Tag>
    );
  }

  return (
    <PopperTooltip
      placement={tooltipSide}
      contentClassName={classes.richTooltipOuter}
      innerClassName={classes.richTooltipInner}
      className={classes.richTooltip}
      cardVariant={"rounded"}
      tooltipContent={
        <div className={classes.richTooltipContentContainer}>
          <div className={classes.richTooltipContent}>{message}</div>
          {linkText && (
            <div className={classes.richTooltipAction}>
              <Button href={linkUrl} variant="text">
                {linkText}
              </Button>
            </div>
          )}
        </div>
      }
    >
      <Tag variant={variant} icon={ChipIcon} iconPosition="start" className={tagStyle}>
        {chipText}
      </Tag>
    </PopperTooltip>
  );
};

export default memo(RichTooltip);
